module.exports = __webpack_public_path__ + "img/pc_board.8a767a4.webp";